// extracted by mini-css-extract-plugin
export default {"orgPackUpDiv":"supGuidePackUpload_orgPackUpDiv__Wt2vp"};